import React,{lazy, Suspense} from 'react';
import './home.scss'
import Users from '../masters/Users';
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom'


import { Route, Routes } from 'react-router-dom';
import Loader from '../loader/Loader';
import ViewProject from '../masters/ViewProject';

// const CreateCV = lazy(()=>import('../createCV/CreateCV'))
// const Dashboard = lazy(()=>import('../dashboard/Dashboard'))
import Dashboard from '../dashboard/Dashboard';
import CreateCV from '../createCV/CreateCV';

import VersionControlSystem from '../masters/VersionControlSystem';
import WebServices from '../masters/WebServices';
import OtherSkills from '../masters/OtherSkills';
import OperatingSystems from '../masters/OperatingSystems';
import GoogleComponents from '../masters/GoogleComponents';
import Setting from '../masters/setting/Setting';
import ProtectedRoutes from '../routes/ProtectedRoutes';
import Login from '../login/Login';
import PublicRoutes from '../routes/PublicRoutes';
import WithNavbar from './WithNavbar';
import IDE from '../masters/IDE';
import Framework from '../masters/Framework';
import Technology from '../masters/Technology';
import Vendor from '../masters/Vendor';
import Responsibility from '../masters/Responsibility';
import RoleSetting from '../roleSetting/RoleSetting';
import Tool from '../masters/Tool';
import Designation from '../masters/Designation';
import NotFound from '../routes/error/NotFound';
import ErrorBondry from '../routes/error/ErrorBoundary';
import ForgetPassword from '../Forget-Password/ForgetPassword';
import MyProfile from '../myProfile/MyProfile';
import ChangePassword from '../ChangePassword/ChangePassword';
import ResetPassword from '../Forget-Password/ResetPassword';
import CreatedCV from '../masters/CreatedCV'


// const VersionControlSystem = lazy(()=>import('../masters/VersionControlSystem'))
// const WebServices = lazy(()=>import('../masters/WebServices'))
// const OtherSkills = lazy(()=>import('../masters/OtherSkills'))
// const OperatingSystems = lazy(()=>import('../masters/OperatingSystems'))
// const GoogleComponents = lazy(()=>import('../masters/GoogleComponents'))
// const Setting = lazy(()=>import( '../masters/setting/Setting'))
// const ProtectedRoutes = lazy(()=>import('../routes/ProtectedRoutes'))
// const Login = lazy(()=>import('../../login/Login'))
// const PublicRoutes = lazy(()=>import('../routes/PublicRoutes'))
// const WithNavbar = lazy(()=>import('./WithNavbar'))
// const IDE = lazy(()=>import('../masters/IDE'))
// const Framework = lazy(()=>import('../masters/Framework'))
// const Technology = lazy(()=>import('../masters/Technology.js'))
// const Responsibility = lazy(()=>import('../masters/Responsibility.js'))
// const RoleSetting = lazy(()=>import('../roleSetting/RoleSetting.js'))
// const Tool = lazy(()=>import('../masters/Tool.js'))
// const Designation = lazy(()=>import('../masters/Designation.js'))

const Home = () => {

      const navigate = useNavigate();
      
  return (
            //  <Suspense fallback={<Loader/>} >
            <ErrorBondry>
                <Routes>
                          <Route element={<WithNavbar/>}>
                             <Route element={<ProtectedRoutes />}>
                             <Route exact path='/dashboard' element={<React.Suspense><Dashboard/></React.Suspense>}></Route>
                             <Route exact path='/create-cv' element={<CreateCV/>}/>
                             <Route exact path='/resources' element={<Users/>}/>
                             <Route exact path='/designation' element={<Designation/>}/>
                             <Route exact path='/createdcv' element={<CreatedCV/>}/>
                             <Route exact path='/project/admin/:id' element={<ViewProject/>}/>
                             <Route exact path='/language' element={<Technology/>}/>
                             <Route exact path='/tool' element={<Tool/>}/>
                             <Route exact path='/framework' element={<Framework/>}/>
                             <Route exact path='/vendor' element={<Vendor/>}/>
                             <Route exact path='/software' element={<IDE/>}/>
                             <Route exact path='/version-control' element={<VersionControlSystem/>}/>
                             <Route exact path='/web-services' element={<WebServices/>}/>
                             <Route exact path='/other-skills' element={<OtherSkills/>}/>
                             <Route exact path='/operating-systems' element={<OperatingSystems/>}/>
                             <Route exact path='/external-components' element={<GoogleComponents/>}/>
                             <Route exact path='/setting' element={<Setting/>}/>
                             <Route exact path='/responsibility' element={<Responsibility/>}/>
                             <Route exact path='/role/permission/:id' element={<RoleSetting/>}/>
                             {/* <Route path=':pageName' element={<NotFound />} ></Route> */}
                             <Route path='/MyProfile' element={<MyProfile />} ></Route>
                             <Route path='/changepassword' element={<ChangePassword />} ></Route>
                             </Route>
                          </Route>
                           <Route element={<PublicRoutes/>}>
                                 <Route path='/' element={<Login />} ></Route>
                                 <Route path={`/forgetpassword`} element={<ForgetPassword />} ></Route>
                                 <Route path='/forgot-password' element={<ResetPassword />} ></Route>
                                 
                                 
                           </Route>
                           <Route path=':pageName' element={<NotFound />} ></Route>

                  </Routes>
                  </ErrorBondry>
            //  </Suspense>
) 
};

export default Home;
